module.exports = __webpack_public_path__ + "static/img/qrhead.b1fc7b1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/qrhead.png
// module id = dz+/
// module chunks = 1